import { Directive, Output, EventEmitter, HostListener } from '@angular/core';

@Directive({ selector: '[longPress]' })
export class LongPressDirective {
    private timeout: any;
    @Output() longPress = new EventEmitter();

    @HostListener('touchstart', ['$event'])
    @HostListener('mousedown', ['$event'])
    onMouseDown(event: any) {
        this.timeout = setTimeout(() => {
            this.longPress.emit(event);
        }, 500);
    }

    @HostListener('touchend')
    @HostListener('mouseup')
    @HostListener('mouseleave')
    endPress() {
        clearTimeout(this.timeout);
    }
}
